/**
 * @desc 导出财务税务表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.stockOccupyDetail.exportFinanceAndTaxationReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/stockOccupyDetail/exportFinanceAndTaxationReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
